<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useNotificationStore } from "@/store";
import Notification from "./Notification.vue";
import { computed } from 'vue';

const { notifications } = storeToRefs(useNotificationStore());

function close(id: number) {
  useNotificationStore().closeNotification(id);
}

function beforeLeave(el: any) {
  const {marginLeft, marginTop, width, height} = window.getComputedStyle(el)
  el.style.left = `${el.offsetLeft - parseFloat(marginLeft)}px`
  el.style.top = `${el.offsetTop - parseFloat(marginTop)}px`
  el.style.width = width
  el.style.height = height
}
</script>
<template>
<!-- Global notification live region -->
<div class="fixed inset-0 flex items-start justify-end p-6 px-4 py-12 pointer-events-none">
  <div class="w-full max-w-sm">
    <div>
    <TransitionGroup @before-leave="beforeLeave" tag="div" name="slide-fade">
      <div
        v-for="[id, notification] in Object.entries(notifications)"
        v-bind:key="id"
      >
        <Notification
          @close="close(notification.id)"
          @cancel-request="() => {
            notification.eventBus.emit('cancel-request');
            close(notification.id)
          }"
          @mouseover="notification.controls.pause()"
          @mouseleave="notification.controls.resume()"
          :notification-id="notification.id"
          :data="notification.props"
          :remaining-duration="notification.duration"
          v-bind:key="id"
          class="flex items-start"
        />
      </div> 
    </TransitionGroup>
    </div>
  </div>
</div>
</template>

<style>
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
  position: absolute;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(0.75rem);
  opacity: 0;
}

.slide-fade-move {
  transition: all 0.5s;
}
</style>
